<template>
	<div class="bootbox modal fade in show" tabindex="-1" role="dialog" style="display: block;">
		<div :class="`modal-dialog ${popupClass}`">
			<div class="modal-content" :style="cssValue">
				<header class="modal-header" v-if="titleText">
					<b style="font-size: 20px; color: #15addb">{{titleText}}</b>
					<slot name="closeBtn"></slot>
				</header>
				<div class="modal-body" >
					<slot></slot>
				</div>
                <footer class="modal-footer">
                    <slot name="modal-footer"></slot>
                </footer>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props:{
        cssValue:{
            type: String
        },
		popupClass:{
			type: String
		},
		titleText:{
			type: String
		},
    },
	mounted(){
		this.$emit("loadFunction");
		// Ensure background doesn't scroll while modal is open
		try {
			document && document.body && document.body.classList.add('modal-open');
		} catch (e) { /* no-op */ }
	},
	destroyed(){
		// Cleanup any lingering bootstrap backdrops only when no other modals are shown
		this.$nextTick(() => {
			try {
				const anyOtherShown = !!document.querySelector('.modal.show');
				if (!anyOtherShown) {
					document.querySelectorAll('.modal-backdrop').forEach(b => {
						b.parentElement && b.parentElement.removeChild(b);
					});
					document.body.classList.remove('modal-open');
					// Remove potential inline styles set by Bootstrap
					document.body.style.removeProperty('padding-right');
					document.body.style.removeProperty('overflow');
				}
			} catch (e) { /* no-op */ }
		});
	}
}
</script>
<style scoped>
@media only screen and (max-device-height : 375px){
	.bootbox-body{
		max-height:270px;
        overflow-y:auto;
        overflow-x:hidden;
	}
}
@media only screen and (min-device-height : 376px) and (max-device-height : 414px){
	.bootbox-body{
		max-height:300px;
        overflow-y:auto;
        overflow-x:hidden;
	}
}
@media only screen and (min-device-height : 415px) and (max-device-height : 667px){
	.bootbox-body{
		max-height:480px;
        overflow-y:auto;
        overflow-x:hidden;
	}
}
@media only screen and (min-device-height : 668px) and (max-device-height : 736px) {
	.bootbox-body{
		max-height:500px;
        overflow-y:auto;
        overflow-x:hidden;
	}
}
@media only screen and (min-device-height : 737px) {
	.bootbox-body{
		max-height:560px;
        overflow-y:auto;
        overflow-x:hidden;
	}
}
</style>